import styled from 'styled-components';
import Text from '../../../../components/Text';

// PIN requirements under the heading, spaced off the first field.
export const Requirements = styled(Text)`
  margin: 0 0 20px;
`;
